import React, { createContext, useContext, useState, useEffect } from "react";
import { useApi } from "./ApiClient";
import { useAuth } from "react-oidc-context";

const SubjectContext = createContext();

export const SubjectProvider = ({ children }) => {
  const [subjectData, setSubjectData] = useState(() => {
    const stored = localStorage.getItem("subjectStatus");
    return stored ? JSON.parse(stored) : null;
  });

  const api = useApi(process.env.REACT_APP_VAF_BASE_URL);
  const auth = useAuth();

  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  // Cache for dashboard details per subject
  const [dashboardCache, setDashboardCache] = useState({});
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await api.get(`getAllSubjects`);
        const data = response.data.data;
        setSubjects(data);
      } catch (error) {
        console.log("error", error);
      }
    };
  if(auth.user) {
    fetchSubjects();
  }
  }, [auth.user]);

  useEffect(() => {
    if (subjectData) {
      localStorage.setItem("subjectStatus", JSON.stringify(subjectData));
    }
  }, [subjectData]);

  return (
    <SubjectContext.Provider
      value={{
        subjectData,
        setSubjectData,
        subjects,
        loading,
        setLoading,
        dashboardCache,
        setDashboardCache,
      }}
    >
      {children}
    </SubjectContext.Provider>
  );
};

export const useSubject = () => useContext(SubjectContext);
